module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_10-ee6f34fbfc55fd62052c19340862d36c.jpg";